export default {
    formId: 'agentsForm',
    formField: {
        name: {
            name: 'name',
            label: 'Nombre del Agente',
            requiredErrorMsg: 'El nombre es requerido'
        },
        description: {
            name: 'description',
            label: 'Descripción'
        },
        service_id: {
            name: 'service_id',
            label: 'Servicio IA',
            requiredErrorMsg: 'El servicio IA es requerido'
        },
        systemPrompt: {
            name: 'systemPrompt',
            label: 'System Prompt',
            requiredErrorMsg: 'El prompt de sistema es requerido'
        },
        temperature: {
            name: 'temperature',
            label: 'Temperatura (0 - 2)'
        },
        topP: {
            name: 'topP',
            label: 'Top P (0 - 1)'
        },
        maxTokens: {
            name: 'maxTokens',
            label: 'Máximo de Tokens'
        },
        enableTools: {
            name: 'enableTools',
            label: 'Habilitar Herramientas'
        },
        enableMemory: {
            name: 'enableMemory',
            label: 'Habilitar Memoria'
        },
        enableReasoning: {
            name: 'enableReasoning',
            label: 'Habilitar Razonamiento'
        },
        enableFunctionCall: {
            name: 'enableFunctionCall',
            label: 'Habilitar Llamada de Funciones'
        },
        enableSearch: {
            name: 'enableSearch',
            label: 'Habilitar Búsqueda'
        },
        enableCodeExecution: {
            name: 'enableCodeExecution',
            label: 'Habilitar Ejecución de Código'
        },
        executionMode: {
            name: 'executionMode',
            label: 'Modo de Ejecución'
        }
    }
}
